<template>
  <div class="basic-info-box page-primary">
    <el-form
      class="form public-form-primary"
      :model="form"
      :rules="rules"
      label-width="120px"
      ref="form">
      <el-form-item
        v-if="isStarRiver"
        label="项目名称:"
        class="project-name"
        prop="projName">
        <el-input
          class="input-primary"
          :disabled="!editFlag"
          v-model="form.projName"
          placeholder="请输入项目名称"
          :maxlength="30"
          show-word-limit />
      </el-form-item>
      <el-form-item
        v-else
        label="项目名称:"
        class="project-name"
        prop="projName">
        <div
          v-if="!isAdmin()"
          class="admin-input not-edit">
          <el-input
            class="input-primary"
            :readonly="!isAdmin()"
            :disabled="!isAdmin()"
            v-model="form.projName"
            placeholder="请输入项目名称"
            :maxlength="30"
            show-word-limit></el-input>
        </div>
        <div
          v-if="isAdmin()"
          class="admin-input-box">
          <div class="admin-input">
            <el-input
              class="input-primary"
              :disabled="!editNameFlag"
              v-model="form.projName"
              placeholder="请输入项目名称"
              :maxlength="30"
              show-word-limit></el-input>
          </div>
          <div class="operation-area">
            <div
              class="operation-area-icon"
              v-if="editNameFlag">
              <i
                class="el-icon-check icon1"
                @click="saveSuperAdminName"></i>
              <i
                class="el-icon-close icon2"
                @click="cancelEditName"></i>
            </div>
            <div class="operation-area-btn">
              <el-button
                class="text-btn"
                v-if="!editNameFlag"
                type="text"
                @click="editName"
                >重命名</el-button
              >
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="isBindProj"
        label="项目关联:">
        <div class="common-select-box">
          <el-select
            class="select-primary"
            size="small"
            remote
            filterable
            v-model="bindProjId"
            clearable
            :remote-method="filterCustomerProj"
            :popper-append-to-body="false"
            placeholder="请选择需要关联的项目"
            :disabled="!editFlag"
            @clear="handleClearFilter">
            <div v-infinite-scroll="handleScroll">
              <el-option
                v-for="(item, index) in customerProjList"
                :key="index"
                :label="item.SectionName"
                :value="item.SectionGUID">
                <div
                  class="text-overflow"
                  :title="item.SectionName">
                  {{ item.SectionName }}
                </div>
              </el-option>
            </div>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item
        label="项目地点:"
        v-if="!baiduDisabled">
        <el-input
          class="input-primary"
          :disabled="!editFlag"
          readonly
          placeholder="请选择项目地点"
          v-model="form.location.streetName">
          <i
            v-if="editFlag"
            slot="suffix"
            class="el-icon-location-outline icon"
            @click="addLocation" />
        </el-input>
      </el-form-item>
      <el-form-item
        label="项目概述:"
        prop="overview">
        <el-input
          class="input-primary"
          :disabled="!editFlag"
          v-model="form.overview"
          autocomplete="off"
          placeholder="请输入项目概况"
          type="textarea"
          maxlength="200"
          rows="5"
          show-word-limit />
      </el-form-item>
      <el-form-item label="缩略图:">
        <div class="avatar-uploader">
          <el-upload
            class="upload-primary"
            ref="upload"
            :disabled="!editFlag"
            :class="`${!editFlag ? 'is-disabled' : ''}`"
            :action="action"
            :headers="headers"
            :data="uploadParams"
            name="FileInfo"
            accept=".jpg,.jpeg,.png,.gif,.tif,.psd"
            :show-file-list="false"
            :on-change="handleChange"
            :on-success="handleAvatarSuccess"
            :on-error="onAvatarError"
            :auto-upload="false">
            <img
              :class="form.thumbnail ? 'avatar not-avatar' : 'avatar'"
              v-if="form.thumbnail"
              :src="`${imageBaseUrl}/${
                form.thumbnail
              }?token=${getTokenId()}`" />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <div class="img-description public-tips-primary">
            支持jpg、jpeg、png、gif、bmp、tif格式，推荐尺寸为350×220
          </div>
        </div>
      </el-form-item>
      <el-form-item label="创建人:">
        <span class="form-item-color">{{ projectInfo.creatorName }}</span>
      </el-form-item>
      <el-form-item label="创建时间:">
        <span class="form-item-color">
          {{ formatTime(projectInfo.creationTime) }}
        </span>
      </el-form-item>
      <el-form-item label="更新时间:">
        <span class="form-item-color">
          {{
            projectInfo.lastModificationTime
              ? formatTime(projectInfo.lastModificationTime)
              : formatTime(projectInfo.creationTime)
          }}
        </span>
      </el-form-item>
    </el-form>
    <div
      class="common-button-box"
      v-if="isEditBtnVisible">
      <el-button
        size="small"
        class="normal-btn"
        @click="handelClick">
        {{ `${editFlag ? '取消' : '编辑'}` }}
      </el-button>
      <el-button
        v-show="editFlag"
        type="primary"
        class="primary-btn"
        size="small"
        @click="saveUpdate">
        保存
      </el-button>
    </div>
    <div v-show="locationDialogVisible">
      <drag-dialog
        title="选择项目地点"
        :width="800"
        :visible.sync="mapVisible"
        :footerBtn="['cancel', 'submit']"
        :defaultTop="155"
        :defaultLeft="530"
        :submit="submitLocation"
        :cancel="cancelLocation">
        <div class="map-box">
          <div
            id="bmap"
            class="map-container" />
          <div class="search-box">
            <el-input
              class="input-primary"
              id="suggestId"
              v-model="keywords"
              placeholder="请输入地点名称" />
          </div>
        </div>
      </drag-dialog>
    </div>
  </div>
</template>

<script>
import dragDialog from '@/components/DragDialog.vue'
import {
  getBase64,
  compressImgBySize,
  formatTime,
  getToken,
  getTokenId
} from '@/utils/generalMethods'

import { Store } from '@/utils/store'

import axios from 'axios'
import {
  getSingleProjectList,
  modifySingleProject,
  modifySingleProjectName
} from '@/service/interface'

let BMapGL = null
const municipality = ['北京市', '天津市', '上海市', '重庆市']
const CompressSize = 2 * 1024 * 1024
export default {
  data() {
    return {
      isStarRiver: window.isStarRiver,

      imageBaseUrl: window.imageBaseUrl,
      baiduDisabled: window.baiduDisabled,
      editFlag: false,
      projectInfo: {},
      locationDialogVisible: false,
      mapVisible: true,
      keywords: '',
      projectTypeList: [
        {
          value: 0,
          label: '单项目'
        },
        {
          value: 1,
          label: '集群项目'
        }
      ],
      headers: {
        Authorization: this.getToken()
      },
      uploadParams: {
        FileSize: '',
        FileName: ''
      },
      form: {
        projName: '',
        location: {
          cityName: '',
          streetName: '',
          coord: ''
        },
        overview: '',
        thumbnail: ''
      },
      editNameFlag: false,

      // 绑定第三方客户项目相关
      isBindProj: window.isBindProj,
      customerToken: '',
      originBindSectionGUID: '',
      bindProjId: '',
      customerProjList: [],
      currPage: 1,
      pageSize: 20,
      isAllProjLoaded: false,

      rules: {
        projName: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          },
          {
            pattern: /^\S*$/g,
            message: '禁止输入空格',
            trigger: 'change'
          }
        ]
      }
    }
  },
  components: {
    dragDialog
  },
  computed: {
    isEditBtnVisible() {
      // 如果不是 StarRiver 或者有权限，则可见
      return !window.isStarRiver || this.isChecked('Project.Single.ReName')
    }
  },
  created() {
    BMapGL = window.BMapGL
    this.initData()

    if (window.isBindProj) {
      this.getBindProjId().then(originBindSectionGUID => {
        this.originBindSectionGUID = originBindSectionGUID
        this.initCustomerProjList(originBindSectionGUID).then(() => {
          this.bindProjId = originBindSectionGUID
        })
      })
    }
  },
  watch: {
    locationDialogVisible: function (newValue) {
      if (newValue) {
        if (!this.map) {
          this.initMap()
        }
      }
    }
  },
  methods: {
    initData() {
      this.action = `${
        window.serverUrl
      }/${this.$logServeCof()}/project/fileManage/v3/projectImage/upload`
      this.getProjectInfo().then(projectInfo => {
        this.projectInfo = projectInfo
        this.form = {
          projId: projectInfo.projId,
          projName: projectInfo.projName,
          location: projectInfo.location ? projectInfo.location : {},
          overview: projectInfo.overview,
          thumbnail: projectInfo.thumbnail
        }
      })
    },
    getProjectInfo() {
      let projId = this.$route.params.projId
      return new Promise(resolve => {
        getSingleProjectList({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let projInfo = data[0]
            resolve(projInfo)
          }
        })
      })
    },
    saveName() {
      return new Promise(resolve => {
        let params = {
          projId: this.form.projId,
          projName: this.form.projName
        }
        modifySingleProjectName(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    handleChange(file) {
      this.$set(this.uploadParams, 'FileName', file.name)

      if (file.size < CompressSize) {
        this.$set(this.uploadParams, 'FileSize', file.size)
        this.$refs.upload.submit()
      } else {
        this.getBase64(file.raw).then(response => {
          this.compressImgBySize(response, 2 * 1024).then(res => {
            let fileOfBlob = new File([res], file.name)
            this.$set(this.uploadParams, 'FileSize', fileOfBlob.size)
            this.$set(this.uploadParams, 'FileInfo', fileOfBlob)
            this.$refs.upload.submit()
          })
        })
      }
    },
    handleAvatarSuccess(response, file) {
      // 图片上传成功
      if (response.isSuccess) {
        let data = response.data
        this.form.thumbnail = data.savePath
      } else {
        this.$message.error(response.errMsg)
      }
    },
    onAvatarError() {
      this.$message.error('图片上传失败')
    },
    handelClick() {
      if (this.editFlag) {
        if (window.isBindProj) {
          this.getBindProjId().then(originBindSectionGUID => {
            this.originBindSectionGUID = originBindSectionGUID
            this.initCustomerProjList(originBindSectionGUID).then(() => {
              this.bindProjId = originBindSectionGUID

              this.initData()
              this.editFlag = false
            })
          })
        } else {
          this.initData()
          this.editFlag = false
        }
      } else {
        this.editFlag = true
      }
    },
    saveUpdate() {
      if (window.isStarRiver) {
        this.saveName().then(() => {
          let params = {
            projId: this.form.projId,
            location: this.form.location,
            overview: this.form.overview,
            thumbnail: this.form.thumbnail
          }
          modifySingleProject(params).then(response => {
            if (response.isSuccess) {
              let blackholeProjId = this.form.projId
              this.bindThirdPartyProj(blackholeProjId).then(() => {
                this.getProjectInfo().then(projInfo => {
                  this.$message.success('修改成功!')
                  this.projectInfo = projInfo
                  this.editFlag = false
                })
              })
            }
          })
        })
      } else {
        let params = {
          projId: this.form.projId,
          location: this.form.location,
          overview: this.form.overview,
          thumbnail: this.form.thumbnail
        }
        modifySingleProject(params).then(response => {
          if (response.isSuccess) {
            let blackholeProjId = this.form.projId
            this.bindThirdPartyProj(blackholeProjId).then(() => {
              this.getProjectInfo().then(projInfo => {
                this.$message.success('修改成功!')
                this.projectInfo = projInfo
                this.editFlag = false
              })
            })
          }
        })
      }
    },
    initMap() {
      this.map = new BMapGL.Map('bmap')
      let point = new BMapGL.Point(116.404, 39.915)
      this.map.centerAndZoom(point, 15)
      this.map.enableScrollWheelZoom()
      this.geoCoder = new BMapGL.Geocoder()

      this.map.addEventListener('click', this.mapClick)

      this.autoComplete = new BMapGL.Autocomplete({
        input: 'suggestId',
        location: this.map
      })
      this.autoComplete.addEventListener('onconfirm', this.locationClick)
    },
    mapClick(e) {
      //清除地图上所有的覆盖物
      this.map.clearOverlays()
      let point = e.latlng
      let marker = new BMapGL.Marker(new BMapGL.Point(point.lng, point.lat))
      this.map.addOverlay(marker)

      this.geoCoder.getLocation(point, result => {
        let addressInfo = result.addressComponents

        let cityName = ''
        if (municipality.includes(addressInfo.province)) {
          cityName = `${addressInfo.city}·${addressInfo.district}`
        } else {
          cityName = `${addressInfo.province}·${addressInfo.city}`
        }
        let streetName = `${addressInfo.city}${addressInfo.district}${addressInfo.street}`
        let coord = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`

        this.keywords = streetName

        this.addressInfo = {
          cityName,
          streetName,
          coord
        }
      })
    },
    locationClick(e) {
      //鼠标点击下拉列表后的事件
      let value = e.item.value
      this.keywords = value.business

      this.locationToAddress(value)
    },
    locationToAddress(value) {
      this.map.clearOverlays()

      let local = new BMapGL.LocalSearch(this.map, {
        //智能搜索
        onSearchComplete: () => {
          let point = local.getResults().getPoi(0).point //获取第一个智能搜索的结果
          this.map.centerAndZoom(point, 18)
          this.map.addOverlay(new BMapGL.Marker(point)) //添加标注

          let addressInfo = local.getResults()

          let cityName = ''
          if (municipality.includes(addressInfo.province)) {
            cityName = `${value.city}·${value.district}`
          } else {
            if (addressInfo.province === value.city) {
              cityName = `${addressInfo.province}·${value.district}`
            } else {
              cityName = `${addressInfo.province}·${value.city}`
            }
          }
          let streetName = value.business
          let coord = `${point.lat.toFixed(6)},${point.lng.toFixed(6)}`

          this.addressInfo = {
            cityName,
            streetName,
            coord
          }
        }
      })

      let address = `${value.province}${value.city}${value.district}${value.street}${value.business}`
      local.search(address)
    },
    addLocation() {
      this.locationDialogVisible = true

      if (this.form.location.streetName) {
        this.$nextTick(() => {
          this.autoComplete.setInputValue(this.form.location.streetName)
          // 清除地图上所有的覆盖物;
          this.map.clearOverlays()
          let latLng = this.form.location.coord.split(',')
          let point = new BMapGL.Point(Number(latLng[1]), Number(latLng[0]))
          let marker = new BMapGL.Marker(point)
          this.map.addOverlay(marker)
          this.map.setCenter(point)
        })
      }
    },
    submitLocation() {
      if (!this.addressInfo) return

      this.form.location = this.addressInfo
      this.clearMap()

      this.locationDialogVisible = false
    },
    cancelLocation() {
      this.clearMap()
      this.locationDialogVisible = false
    },
    clearMap() {
      this.map.clearOverlays()
      this.autoComplete.setInputValue('')
      this.keywords = ''
      let point = new BMapGL.Point(116.404, 39.915)
      this.map.centerAndZoom(point, 15)
    },
    // 绑定第三方项目
    bindThirdPartyProj(blackholeProjId) {
      return new Promise(resolve => {
        if (!window.isBindProj) {
          resolve()
          return
        }

        if (this.originBindSectionGUID === this.bindProjId) {
          resolve()
          return
        }

        this.getCustomerToken().then(access_token => {
          let headers = {
            Authorization: `Bearer ${access_token}`
          }
          let params = {
            sectionGUID: this.bindProjId,
            bimProjectId: blackholeProjId
          }
          let serverUrl = `${window.customerServerUrl}/Project/RelationSectionData`
          axios.post(serverUrl, params, { headers }).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.success) {
                resolve()
              } else {
                this.$message.error(response.errorMessage)
              }
            } else {
              this.customerToken = ''
              this.$message.error('获取第三方请求失败')
            }
          })
        })
      })
    },
    getBindProjId() {
      return new Promise(resolve => {
        this.getCustomerToken().then(access_token => {
          let headers = {
            Authorization: `Bearer ${access_token}`
          }
          let bimProjectId = this.$route.params.projId
          let params = { bimProjectId }
          let serverUrl = `${window.customerServerUrl}/Project/GetRelationSectionData`
          axios.post(serverUrl, params, { headers }).then(result => {
            if (result.status === 200) {
              let response = result.data
              let sectionGUID = response.Data
              let originBindSectionGUID = ''
              if (sectionGUID.length) {
                originBindSectionGUID = sectionGUID[0].SectionGUID
              }
              resolve(originBindSectionGUID)
            } else {
              this.customerToken = ''
              this.$message.error('获取第三方请求失败')
            }
          })
        })
      })
    },
    handleClearFilter() {
      this.currPage = 1
      this.isAllProjLoaded = false
      this.customerProjName = ''

      this.queryCustomerProjList().then(projList => {
        this.customerProjList = projList
      })
    },
    filterCustomerProj(customerProjName) {
      this.currPage = 1
      this.isAllProjLoaded = false
      this.customerProjName = customerProjName

      this.queryCustomerProjList().then(projList => {
        this.customerProjList = projList
      })
    },
    handleScroll() {
      if (this.isAllProjLoaded || this.customerProjName) return
      this.currPage++

      this.queryCustomerProjList().then(projList => {
        if (projList.length) {
          this.customerProjList = [...this.customerProjList, ...projList]
        } else {
          this.isAllProjLoaded = true
        }
      })
    },
    initCustomerProjList(originBindSectionGUID) {
      return new Promise(resolve => {
        this.currPage = 1
        this.queryCustomerProjList(originBindSectionGUID).then(projList => {
          this.customerProjList = projList
          resolve()
        })
      })
    },
    // 获取客户token
    getCustomerToken() {
      return new Promise(resolve => {
        if (this.customerToken) {
          resolve(this.customerToken)
        } else {
          let params = {
            client_id: window.customerClientId,
            client_secret: window.customerSecretKey
          }
          let serverUrl = `${window.customerServerUrl}/MIPApiAuth/Token`
          axios.post(serverUrl, params).then(result => {
            if (result.status === 200) {
              let response = result.data
              let access_token = response.access_token
              resolve(access_token)
            } else {
              this.$message.error('获取第三方请求失败')
            }
          })
        }
      })
    },
    queryCustomerProjList(sectionGUID) {
      return new Promise(resolve => {
        this.getCustomerToken().then(access_token => {
          let headers = {
            Authorization: `Bearer ${access_token}`
          }
          let params = {
            sectionGUID: sectionGUID,
            sectionName: this.customerProjName,
            page: this.currPage - 1,
            page_size: this.pageSize
          }
          let serverUrl = `${window.customerServerUrl}/Project/GetSectionData`
          axios.post(serverUrl, params, { headers }).then(result => {
            if (result.status === 200) {
              let response = result.data
              let projList = response.Data
              resolve(projList)
            } else {
              this.customerToken = ''
              this.$message.error('获取第三方请求失败')
            }
          })
        })
      })
    },
    isAdmin() {
      if (!this.isChecked('Project.Single.ReName')) {
        return false
      } else {
        return true
      }
    },
    editName() {
      this.editNameFlag = true
    },
    saveSuperAdminName() {
      let params = {
        projId: this.form.projId,
        projName: this.form.projName
      }
      modifySingleProjectName(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('修改成功！！！')
          this.editNameFlag = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    cancelEditName() {
      this.form.projName = this.projectInfo.projName
      this.editNameFlag = false
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getBase64,
    compressImgBySize,
    getToken,
    formatTime,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.basic-info-box {
  margin-bottom: 16px;
  background: var(--basicinfo-page-bgColor);
  overflow-y: auto;
  flex: 1;

  .form {
    width: 40%;

    :deep(.el-form-item) {
      .el-textarea__inner,
      .el-input__inner {
        background-color: var(--basicinfo-input-bgColor) !important;
        border: 1px solid var(--base-bg-dark-color62) !important;
        transition: none;

        &:focus {
          border: 1px solid var(--base-primary-bgColor) !important;
          box-shadow: var(--base-bg-light-color35);
        }

        &:hover {
          border: 1px solid var(--base-primary-bgColor) !important;
          box-shadow: var(--base-bg-light-color35);
        }
      }

      .is-disabled {
        .el-textarea__inner,
        .el-input__inner {
          background-color: var(--basicinfo-input-disabled-bgColor) !important;
          border: 1px solid var(--base-bg-dark-color62) !important;

          &:focus {
            background-color: var(
              --basicinfo-input-disabled-bgColor
            ) !important;
            border: 1px solid var(--base-bg-dark-color62) !important;
            box-shadow: none !important;
          }

          &:hover {
            background-color: var(
              --basicinfo-input-disabled-bgColor
            ) !important;
            border: 1px solid var(--base-bg-dark-color62) !important;
            box-shadow: none !important;
          }
        }
      }
    }

    .el-form-item {
      .el-select {
        width: 100%;
      }

      .icon {
        font-size: 25px;
        line-height: 40px;
        cursor: pointer;
      }
    }

    .admin-input-box {
      display: flex;

      .admin-input {
        width: 100%;

        .is-disabled {
          :deep(.el-input__inner) {
            background-color: var(
              --basicinfo-input-disabled-bgColor
            ) !important;
            border: 1px solid var(--base-bg-dark-color62) !important;
            cursor: auto;
            transition: none;

            &:hover,
            &:focus {
              box-shadow: none !important;
            }
          }
        }
      }

      .operation-area {
        .icon1 {
          margin-left: 10px;
          line-height: 30px;
          color: var(--base-light-color3);
          cursor: pointer;
        }

        .icon2 {
          margin-left: 10px;
          line-height: 30px;
          color: var(--base-light-color4);
          cursor: pointer;
        }

        &-icon {
          display: flex;
          align-items: center;
          padding-left: 2px;
          height: 100%;
        }

        &-btn {
          padding-left: 20px;
        }
      }
    }

    .avatar-uploader {
      display: flex;
      width: 100%;
      :deep(.el-upload) {
        padding: 8px;
        border-radius: 6px;
        cursor: pointer;
        width: 210px;
        height: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-color: var(--base-bg-dark-color62);

        &:hover {
          background: var(--base-bg-dark-color61);
        }

        &:has(.not-avatar):hover {
          background: none;
        }
        .avatar-uploader-icon {
          font-size: 32px;
          color: var(--upload-icon-color);
          line-height: 120px;
          text-align: center;
        }

        .avatar {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }

      .is-disabled {
        cursor: not-allowed;
        :deep(.el-upload) {
          background-color: var(--basicinfo-input-disabled-bgColor);

          &:hover {
            background-color: var(--basicinfo-input-disabled-bgColor);
          }
        }
      }

      .img-description {
        width: 280px;
        color: var(--base-light-color2);
        line-height: 25px;
        margin-left: 20px;
      }
    }
  }
  .common-button-box {
    padding: 16px 0;
    position: sticky;
    bottom: 0;
  }
  .form-item-color {
    color: var(--basicinfo-normal-text-color);
  }
  .map-box {
    height: 600px;

    .map-container {
      height: 100%;
    }

    .search-box {
      position: absolute;
      top: 65px;
      left: 20px;
      width: 300px;
      z-index: 9;
    }
  }
}
</style>
